import PageLayout from "@components/PageLayout";
import { HighGrowthVault } from "@components/V2/Vault";
import { YieldVaultProider } from "@providers/YieldVaultProvider";
import { fetchStrapiData } from "@services/strapi";

export const getStaticProps = async () => {
  // Fetch CMS data at build time (not real-time API data)
  const res = await fetchStrapiData("strategy-allocations");

  return {
    props: {
      page: {
        data: {
          cmsAllocations: (() => {
            if (res?.data?.length > 0) {
              const vaultData = res.data.find(
                (data: any) =>
                  data?.attributes?.vault_name === "high_growth_vault"
              );

              return vaultData?.attributes || [];
            }
            return [];
          })(),
        },
      },
    },
  };
};

const YieldVaultPage = (props: { page: any }) => {
  return (
    <PageLayout extraMarginTop={false}>
      <YieldVaultProider
        data={{ cmsAllocations: props.page.data.cmsAllocations }}
      >
        <HighGrowthVault />
      </YieldVaultProider>
    </PageLayout>
  );
};

export default YieldVaultPage;
